var quizQuestions = [
    {
        question: "In Deutschland dürfen Menschen offen etwas gegen die Regierung sagen, weil ... - hier Religionsfreiheit gilt.",
        answers: [
            {
                type: "your level A1",
                content: "hier Religionsfreiheit gilt"
            },
            {
                type: "your level A2",
                content: "die Menschen Steuern zahlen."
            },
            {
                type: "your level B1",
                content: "die Menschen das Wahlrecht haben."
            },
            {
                type: "your level B2",
                content: "hier Meinungsfreiheit gilt."
            }
        ]
    },
    {
        question: "In Deutschland können Eltern bis zum 14. Lebensjahr ihres Kindes entscheiden, ob es in der Schule am ...",
        answers: [
            {
                type: "your level A1",
                content: "Geschichtsunterricht teilnimmt."
            },
            {
                type: "your level A2",
                content: "Religionsunterricht teilnimmt."
            },
            {
                type: "your level B1",
                content: "Politikunterricht teilnimmt."
            },
            {
                type: "your level B2",
                content: "Sprachunterricht teilnimmt."
            }
        ]
    },
    {
        question: "Deutschland ist ein Rechtsstaat. Was ist damit gemeint?",
        answers: [
            {
                type: "your level A1",
                content: "Alle Einwohner / Einwohnerinnen und der Staat müssen sich die Gesetze halten."
            },
            {
                type: "your level A2",
                content: "Der Staat muss sich nicht an die Gesetze halten."
            },
            {
                type: "your level B1",
                content: "Nur Deutsche müssen die Gesetze befolgen."
            },
            {
                type: "your level B2",
                content: "Die Gerichte machen die Gesetze."
            }
        ]
    }
];

export default quizQuestions;
